import { SelectCategoryModal } from './kpis/modals/select-category/select-category.modal';
import { SelectCustomerModal } from './kpis/modals/select-customer/select-customer.modal';
import { CreateWorkLogModal } from './work-logs/modals/create-work-log/create-work-log.modal';
import { CreateKpiModal } from './kpis/modals/create-kpi/create-kpi.modal';
import { SelectUserModal } from './observations/modals/select-user/select-user.modal';
import { EditKpiModal } from './kpis/modals/edit-kpi/edit-kpi.modal';

export const Modals = [
    SelectCategoryModal,
    SelectUserModal,
    SelectCustomerModal,
    CreateWorkLogModal,
    CreateKpiModal,
    EditKpiModal,
];



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/modals.ts